import Modal from "~/common/components/Modal";
import { Button, Stack, Typography } from "~/common/mui";
import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";
import { Trans, useTranslation } from "react-i18next";

interface Props {
  onClose: () => void;
  onIgnore: () => void;
  onSetup: () => void;
}

export const LmsInactiveModal = (props: Props) => {
  const isMinTablet = useIsMinTabletSize();
  const { t } = useTranslation();
  return (
    <Modal
      onClose={props.onClose}
      footerChildren={
        <Stack gap={1} direction="row">
          <Button variant={"text"} onClick={props.onIgnore}>
            {t("feature.lms.modal.button.not_now")}
          </Button>
          <Button onClick={props.onSetup}>{t("feature.lms.modal.button.set_up")}</Button>
        </Stack>
      }
    >
      <Typography variant="titleMedium" sx={{ display: "block", margin: 0, pb: 4 }}>
        <Trans i18nKey="feature.lms.modal.inactive.text" />
      </Typography>
    </Modal>
  );
};
